/**
 * Joint & Last Survivor RMD Divisors (IRS Pub 590-B Table II)
 *
 * Generated from IRS Publication 590-B, Appendix B, Table II:
 * IRS Publication 590-B, Appendix B, Table II (Joint Life and Last Survivor Expectancy), https://www.irs.gov/pub/irs-pdf/p590b.pdf
 *
 * Source data: .agents/ds/irs-table2-joint.json
 *
 * Two-dimensional matrix keyed by owner age AND spouse age. Use
 * jointRmdDivisor(ownerAge, spouseAge) to look up a value -- it
 * enforces the IRS "spouse more than 10 years younger" rule.
 */

export const JOINT_RMD_TABLE_II = {
  72: {
    20: 65.1,
    21: 64.2,
    22: 63.2,
    23: 62.2,
    24: 61.3,
    25: 60.3,
    26: 59.3,
    27: 58.4,
    28: 57.4,
    29: 56.5,
    30: 55.5,
    31: 54.5,
    32: 53.6,
    33: 52.6,
    34: 51.7,
    35: 50.8,
    36: 49.8,
    37: 48.9,
    38: 47.9,
    39: 47,
    40: 46,
    41: 45.1,
    42: 44.2,
    43: 43.2,
    44: 42.3,
    45: 41.4,
    46: 40.5,
    47: 39.6,
    48: 38.7,
    49: 37.8,
    50: 36.9,
    51: 36,
    52: 35.2,
    53: 34.3,
    54: 33.5,
    55: 32.7,
    56: 31.9,
    57: 31.1,
    58: 30.3,
    59: 29.5,
    60: 28.8,
    61: 28.1,
  },
  73: {
    20: 65.1,
    21: 64.2,
    22: 63.2,
    23: 62.2,
    24: 61.2,
    25: 60.3,
    26: 59.3,
    27: 58.4,
    28: 57.4,
    29: 56.4,
    30: 55.5,
    31: 54.5,
    32: 53.6,
    33: 52.6,
    34: 51.7,
    35: 50.7,
    36: 49.8,
    37: 48.8,
    38: 47.9,
    39: 46.9,
    40: 46,
    41: 45.1,
    42: 44.1,
    43: 43.2,
    44: 42.3,
    45: 41.4,
    46: 40.4,
    47: 39.5,
    48: 38.6,
    49: 37.7,
    50: 36.8,
    51: 36,
    52: 35.1,
    53: 34.2,
    54: 33.4,
    55: 32.6,
    56: 31.7,
    57: 30.9,
    58: 30.1,
    59: 29.4,
    60: 28.6,
    61: 27.9,
    62: 27.2,
  },
  74: {
    20: 65.1,
    21: 64.1,
    22: 63.2,
    23: 62.2,
    24: 61.2,
    25: 60.3,
    26: 59.3,
    27: 58.3,
    28: 57.4,
    29: 56.4,
    30: 55.5,
    31: 54.5,
    32: 53.6,
    33: 52.6,
    34: 51.7,
    35: 50.7,
    36: 49.8,
    37: 48.8,
    38: 47.9,
    39: 46.9,
    40: 46,
    41: 45,
    42: 44.1,
    43: 43.2,
    44: 42.2,
    45: 41.3,
    46: 40.4,
    47: 39.5,
    48: 38.6,
    49: 37.7,
    50: 36.8,
    51: 35.9,
    52: 35,
    53: 34.1,
    54: 33.3,
    55: 32.4,
    56: 31.6,
    57: 30.8,
    58: 30,
    59: 29.2,
    60: 28.4,
    61: 27.7,
    62: 27,
    63: 26.2,
  },
  75: {
    20: 65.1,
    21: 64.1,
    22: 63.2,
    23: 62.2,
    24: 61.2,
    25: 60.3,
    26: 59.3,
    27: 58.3,
    28: 57.4,
    29: 56.4,
    30: 55.5,
    31: 54.5,
    32: 53.5,
    33: 52.6,
    34: 51.6,
    35: 50.7,
    36: 49.7,
    37: 48.8,
    38: 47.8,
    39: 46.9,
    40: 45.9,
    41: 45,
    42: 44.1,
    43: 43.1,
    44: 42.2,
    45: 41.3,
    46: 40.3,
    47: 39.4,
    48: 38.5,
    49: 37.6,
    50: 36.7,
    51: 35.8,
    52: 34.9,
    53: 34.1,
    54: 33.2,
    55: 32.4,
    56: 31.5,
    57: 30.7,
    58: 29.9,
    59: 29.1,
    60: 28.3,
    61: 27.5,
    62: 26.8,
    63: 26.1,
    64: 25.3,
  },
  76: {
    20: 65.1,
    21: 64.1,
    22: 63.2,
    23: 62.2,
    24: 61.2,
    25: 60.2,
    26: 59.3,
    27: 58.3,
    28: 57.4,
    29: 56.4,
    30: 55.4,
    31: 54.5,
    32: 53.5,
    33: 52.6,
    34: 51.6,
    35: 50.7,
    36: 49.7,
    37: 48.8,
    38: 47.8,
    39: 46.9,
    40: 45.9,
    41: 45,
    42: 44,
    43: 43.1,
    44: 42.2,
    45: 41.2,
    46: 40.3,
    47: 39.4,
    48: 38.5,
    49: 37.5,
    50: 36.6,
    51: 35.7,
    52: 34.9,
    53: 34,
    54: 33.1,
    55: 32.3,
    56: 31.4,
    57: 30.6,
    58: 29.8,
    59: 29,
    60: 28.2,
    61: 27.4,
    62: 26.6,
    63: 25.9,
    64: 25.2,
    65: 24.4,
  },
  77: {
    20: 65.1,
    21: 64.1,
    22: 63.1,
    23: 62.2,
    24: 61.2,
    25: 60.2,
    26: 59.3,
    27: 58.3,
    28: 57.3,
    29: 56.4,
    30: 55.4,
    31: 54.5,
    32: 53.5,
    33: 52.6,
    34: 51.6,
    35: 50.7,
    36: 49.7,
    37: 48.8,
    38: 47.8,
    39: 46.9,
    40: 45.9,
    41: 45,
    42: 44,
    43: 43.1,
    44: 42.1,
    45: 41.2,
    46: 40.3,
    47: 39.3,
    48: 38.4,
    49: 37.5,
    50: 36.6,
    51: 35.7,
    52: 34.8,
    53: 33.9,
    54: 33,
    55: 32.2,
    56: 31.3,
    57: 30.5,
    58: 29.7,
    59: 28.8,
    60: 28,
    61: 27.3,
    62: 26.5,
    63: 25.7,
    64: 25,
    65: 24.3,
    66: 23.5,
  },
  78: {
    20: 65.1,
    21: 64.1,
    22: 63.1,
    23: 62.2,
    24: 61.2,
    25: 60.2,
    26: 59.3,
    27: 58.3,
    28: 57.3,
    29: 56.4,
    30: 55.4,
    31: 54.5,
    32: 53.5,
    33: 52.6,
    34: 51.6,
    35: 50.6,
    36: 49.7,
    37: 48.7,
    38: 47.8,
    39: 46.8,
    40: 45.9,
    41: 44.9,
    42: 44,
    43: 43,
    44: 42.1,
    45: 41.2,
    46: 40.2,
    47: 39.3,
    48: 38.4,
    49: 37.5,
    50: 36.5,
    51: 35.6,
    52: 34.7,
    53: 33.9,
    54: 33,
    55: 32.1,
    56: 31.2,
    57: 30.4,
    58: 29.6,
    59: 28.7,
    60: 27.9,
    61: 27.1,
    62: 26.4,
    63: 25.6,
    64: 24.8,
    65: 24.1,
    66: 23.4,
    67: 22.7,
  },
  79: {
    20: 65.1,
    21: 64.1,
    22: 63.1,
    23: 62.2,
    24: 61.2,
    25: 60.2,
    26: 59.3,
    27: 58.3,
    28: 57.3,
    29: 56.4,
    30: 55.4,
    31: 54.5,
    32: 53.5,
    33: 52.5,
    34: 51.6,
    35: 50.6,
    36: 49.7,
    37: 48.7,
    38: 47.8,
    39: 46.8,
    40: 45.9,
    41: 44.9,
    42: 44,
    43: 43,
    44: 42.1,
    45: 41.1,
    46: 40.2,
    47: 39.3,
    48: 38.3,
    49: 37.4,
    50: 36.5,
    51: 35.6,
    52: 34.7,
    53: 33.8,
    54: 32.9,
    55: 32,
    56: 31.2,
    57: 30.3,
    58: 29.5,
    59: 28.7,
    60: 27.8,
    61: 27,
    62: 26.2,
    63: 25.5,
    64: 24.7,
    65: 23.9,
    66: 23.2,
    67: 22.5,
    68: 21.8,
  },
  80: {
    20: 65.1,
    21: 64.1,
    22: 63.1,
    23: 62.1,
    24: 61.2,
    25: 60.2,
    26: 59.2,
    27: 58.3,
    28: 57.3,
    29: 56.4,
    30: 55.4,
    31: 54.4,
    32: 53.5,
    33: 52.5,
    34: 51.6,
    35: 50.6,
    36: 49.7,
    37: 48.7,
    38: 47.8,
    39: 46.8,
    40: 45.9,
    41: 44.9,
    42: 43.9,
    43: 43,
    44: 42.1,
    45: 41.1,
    46: 40.2,
    47: 39.2,
    48: 38.3,
    49: 37.4,
    50: 36.5,
    51: 35.5,
    52: 34.6,
    53: 33.7,
    54: 32.9,
    55: 32,
    56: 31.1,
    57: 30.3,
    58: 29.4,
    59: 28.6,
    60: 27.8,
    61: 26.9,
    62: 26.1,
    63: 25.3,
    64: 24.6,
    65: 23.8,
    66: 23.1,
    67: 22.3,
    68: 21.6,
    69: 20.9,
  },
  81: {
    20: 65.1,
    21: 64.1,
    22: 63.1,
    23: 62.1,
    24: 61.2,
    25: 60.2,
    26: 59.2,
    27: 58.3,
    28: 57.3,
    29: 56.4,
    30: 55.4,
    31: 54.4,
    32: 53.5,
    33: 52.5,
    34: 51.6,
    35: 50.6,
    36: 49.7,
    37: 48.7,
    38: 47.7,
    39: 46.8,
    40: 45.8,
    41: 44.9,
    42: 43.9,
    43: 43,
    44: 42,
    45: 41.1,
    46: 40.1,
    47: 39.2,
    48: 38.3,
    49: 37.3,
    50: 36.4,
    51: 35.5,
    52: 34.6,
    53: 33.7,
    54: 32.8,
    55: 31.9,
    56: 31.1,
    57: 30.2,
    58: 29.3,
    59: 28.5,
    60: 27.7,
    61: 26.9,
    62: 26,
    63: 25.2,
    64: 24.5,
    65: 23.7,
    66: 22.9,
    67: 22.2,
    68: 21.5,
    69: 20.7,
    70: 20,
  },
  82: {
    20: 65.1,
    21: 64.1,
    22: 63.1,
    23: 62.1,
    24: 61.2,
    25: 60.2,
    26: 59.2,
    27: 58.3,
    28: 57.3,
    29: 56.3,
    30: 55.4,
    31: 54.4,
    32: 53.5,
    33: 52.5,
    34: 51.6,
    35: 50.6,
    36: 49.7,
    37: 48.7,
    38: 47.7,
    39: 46.8,
    40: 45.8,
    41: 44.9,
    42: 43.9,
    43: 43,
    44: 42,
    45: 41.1,
    46: 40.1,
    47: 39.2,
    48: 38.3,
    49: 37.3,
    50: 36.4,
    51: 35.5,
    52: 34.6,
    53: 33.7,
    54: 32.8,
    55: 31.9,
    56: 31,
    57: 30.1,
    58: 29.3,
    59: 28.4,
    60: 27.6,
    61: 26.8,
    62: 26,
    63: 25.2,
    64: 24.4,
    65: 23.6,
    66: 22.8,
    67: 22.1,
    68: 21.3,
    69: 20.6,
    70: 19.9,
    71: 19.2,
  },
  83: {
    20: 65.1,
    21: 64.1,
    22: 63.1,
    23: 62.1,
    24: 61.2,
    25: 60.2,
    26: 59.2,
    27: 58.3,
    28: 57.3,
    29: 56.3,
    30: 55.4,
    31: 54.4,
    32: 53.5,
    33: 52.5,
    34: 51.6,
    35: 50.6,
    36: 49.6,
    37: 48.7,
    38: 47.7,
    39: 46.8,
    40: 45.8,
    41: 44.9,
    42: 43.9,
    43: 43,
    44: 42,
    45: 41.1,
    46: 40.1,
    47: 39.2,
    48: 38.2,
    49: 37.3,
    50: 36.4,
    51: 35.4,
    52: 34.5,
    53: 33.6,
    54: 32.7,
    55: 31.8,
    56: 31,
    57: 30.1,
    58: 29.2,
    59: 28.4,
    60: 27.5,
    61: 26.7,
    62: 25.9,
    63: 25.1,
    64: 24.3,
    65: 23.5,
    66: 22.7,
    67: 22,
    68: 21.2,
    69: 20.5,
    70: 19.7,
    71: 19,
    72: 18.3,
  },
  84: {
    20: 65.1,
    21: 64.1,
    22: 63.1,
    23: 62.1,
    24: 61.2,
    25: 60.2,
    26: 59.2,
    27: 58.3,
    28: 57.3,
    29: 56.3,
    30: 55.4,
    31: 54.4,
    32: 53.5,
    33: 52.5,
    34: 51.5,
    35: 50.6,
    36: 49.6,
    37: 48.7,
    38: 47.7,
    39: 46.8,
    40: 45.8,
    41: 44.9,
    42: 43.9,
    43: 42.9,
    44: 42,
    45: 41,
    46: 40.1,
    47: 39.2,
    48: 38.2,
    49: 37.3,
    50: 36.3,
    51: 35.4,
    52: 34.5,
    53: 33.6,
    54: 32.7,
    55: 31.8,
    56: 30.9,
    57: 30,
    58: 29.2,
    59: 28.3,
    60: 27.5,
    61: 26.7,
    62: 25.8,
    63: 25,
    64: 24.2,
    65: 23.4,
    66: 22.6,
    67: 21.9,
    68: 21.1,
    69: 20.4,
    70: 19.6,
    71: 18.9,
    72: 18.2,
    73: 17.5,
  },
  85: {
    20: 65.1,
    21: 64.1,
    22: 63.1,
    23: 62.1,
    24: 61.2,
    25: 60.2,
    26: 59.2,
    27: 58.3,
    28: 57.3,
    29: 56.3,
    30: 55.4,
    31: 54.4,
    32: 53.5,
    33: 52.5,
    34: 51.5,
    35: 50.6,
    36: 49.6,
    37: 48.7,
    38: 47.7,
    39: 46.8,
    40: 45.8,
    41: 44.8,
    42: 43.9,
    43: 42.9,
    44: 42,
    45: 41,
    46: 40.1,
    47: 39.1,
    48: 38.2,
    49: 37.3,
    50: 36.3,
    51: 35.4,
    52: 34.5,
    53: 33.6,
    54: 32.7,
    55: 31.8,
    56: 30.9,
    57: 30,
    58: 29.1,
    59: 28.3,
    60: 27.4,
    61: 26.6,
    62: 25.8,
    63: 25,
    64: 24.1,
    65: 23.3,
    66: 22.6,
    67: 21.8,
    68: 21,
    69: 20.3,
    70: 19.5,
    71: 18.8,
    72: 18.1,
    73: 17.4,
    74: 16.7,
  },
  86: {
    20: 65.1,
    21: 64.1,
    22: 63.1,
    23: 62.1,
    24: 61.1,
    25: 60.2,
    26: 59.2,
    27: 58.2,
    28: 57.3,
    29: 56.3,
    30: 55.4,
    31: 54.4,
    32: 53.5,
    33: 52.5,
    34: 51.5,
    35: 50.6,
    36: 49.6,
    37: 48.7,
    38: 47.7,
    39: 46.7,
    40: 45.8,
    41: 44.8,
    42: 43.9,
    43: 42.9,
    44: 42,
    45: 41,
    46: 40.1,
    47: 39.1,
    48: 38.2,
    49: 37.2,
    50: 36.3,
    51: 35.4,
    52: 34.5,
    53: 33.5,
    54: 32.6,
    55: 31.7,
    56: 30.9,
    57: 30,
    58: 29.1,
    59: 28.2,
    60: 27.4,
    61: 26.6,
    62: 25.7,
    63: 24.9,
    64: 24.1,
    65: 23.3,
    66: 22.5,
    67: 21.7,
    68: 20.9,
    69: 20.2,
    70: 19.4,
    71: 18.7,
    72: 17.9,
    73: 17.2,
    74: 16.5,
    75: 15.9,
  },
  87: {
    20: 65,
    21: 64.1,
    22: 63.1,
    23: 62.1,
    24: 61.1,
    25: 60.2,
    26: 59.2,
    27: 58.2,
    28: 57.3,
    29: 56.3,
    30: 55.4,
    31: 54.4,
    32: 53.4,
    33: 52.5,
    34: 51.5,
    35: 50.6,
    36: 49.6,
    37: 48.7,
    38: 47.7,
    39: 46.7,
    40: 45.8,
    41: 44.8,
    42: 43.9,
    43: 42.9,
    44: 42,
    45: 41,
    46: 40.1,
    47: 39.1,
    48: 38.2,
    49: 37.2,
    50: 36.3,
    51: 35.4,
    52: 34.4,
    53: 33.5,
    54: 32.6,
    55: 31.7,
    56: 30.8,
    57: 29.9,
    58: 29.1,
    59: 28.2,
    60: 27.4,
    61: 26.5,
    62: 25.7,
    63: 24.9,
    64: 24,
    65: 23.2,
    66: 22.4,
    67: 21.6,
    68: 20.9,
    69: 20.1,
    70: 19.3,
    71: 18.6,
    72: 17.8,
    73: 17.1,
    74: 16.4,
    75: 15.7,
    76: 15.1,
  },
  88: {
    20: 65,
    21: 64.1,
    22: 63.1,
    23: 62.1,
    24: 61.1,
    25: 60.2,
    26: 59.2,
    27: 58.2,
    28: 57.3,
    29: 56.3,
    30: 55.4,
    31: 54.4,
    32: 53.4,
    33: 52.5,
    34: 51.5,
    35: 50.6,
    36: 49.6,
    37: 48.7,
    38: 47.7,
    39: 46.7,
    40: 45.8,
    41: 44.8,
    42: 43.9,
    43: 42.9,
    44: 42,
    45: 41,
    46: 40,
    47: 39.1,
    48: 38.2,
    49: 37.2,
    50: 36.3,
    51: 35.3,
    52: 34.4,
    53: 33.5,
    54: 32.6,
    55: 31.7,
    56: 30.8,
    57: 29.9,
    58: 29,
    59: 28.2,
    60: 27.3,
    61: 26.5,
    62: 25.6,
    63: 24.8,
    64: 24,
    65: 23.2,
    66: 22.4,
    67: 21.6,
    68: 20.8,
    69: 20,
    70: 19.2,
    71: 18.5,
    72: 17.7,
    73: 17,
    74: 16.3,
    75: 15.6,
    76: 14.9,
    77: 14.3,
  },
  89: {
    20: 65,
    21: 64.1,
    22: 63.1,
    23: 62.1,
    24: 61.1,
    25: 60.2,
    26: 59.2,
    27: 58.2,
    28: 57.3,
    29: 56.3,
    30: 55.4,
    31: 54.4,
    32: 53.4,
    33: 52.5,
    34: 51.5,
    35: 50.6,
    36: 49.6,
    37: 48.7,
    38: 47.7,
    39: 46.7,
    40: 45.8,
    41: 44.8,
    42: 43.9,
    43: 42.9,
    44: 41.9,
    45: 41,
    46: 40,
    47: 39.1,
    48: 38.1,
    49: 37.2,
    50: 36.3,
    51: 35.3,
    52: 34.4,
    53: 33.5,
    54: 32.6,
    55: 31.7,
    56: 30.8,
    57: 29.9,
    58: 29,
    59: 28.2,
    60: 27.3,
    61: 26.4,
    62: 25.6,
    63: 24.8,
    64: 24,
    65: 23.1,
    66: 22.3,
    67: 21.5,
    68: 20.7,
    69: 20,
    70: 19.2,
    71: 18.4,
    72: 17.7,
    73: 16.9,
    74: 16.2,
    75: 15.5,
    76: 14.8,
    77: 14.2,
    78: 13.5,
  },
  90: {
    20: 65,
    21: 64.1,
    22: 63.1,
    23: 62.1,
    24: 61.1,
    25: 60.2,
    26: 59.2,
    27: 58.2,
    28: 57.3,
    29: 56.3,
    30: 55.4,
    31: 54.4,
    32: 53.4,
    33: 52.5,
    34: 51.5,
    35: 50.6,
    36: 49.6,
    37: 48.6,
    38: 47.7,
    39: 46.7,
    40: 45.8,
    41: 44.8,
    42: 43.9,
    43: 42.9,
    44: 41.9,
    45: 41,
    46: 40,
    47: 39.1,
    48: 38.1,
    49: 37.2,
    50: 36.3,
    51: 35.3,
    52: 34.4,
    53: 33.5,
    54: 32.6,
    55: 31.7,
    56: 30.8,
    57: 29.9,
    58: 29,
    59: 28.1,
    60: 27.3,
    61: 26.4,
    62: 25.6,
    63: 24.7,
    64: 23.9,
    65: 23.1,
    66: 22.3,
    67: 21.5,
    68: 20.7,
    69: 19.9,
    70: 19.1,
    71: 18.4,
    72: 17.6,
    73: 16.9,
    74: 16.1,
    75: 15.4,
    76: 14.8,
    77: 14.1,
    78: 13.4,
    79: 12.8,
  },
  91: {
    20: 65,
    21: 64.1,
    22: 63.1,
    23: 62.1,
    24: 61.1,
    25: 60.2,
    26: 59.2,
    27: 58.2,
    28: 57.3,
    29: 56.3,
    30: 55.3,
    31: 54.4,
    32: 53.4,
    33: 52.5,
    34: 51.5,
    35: 50.6,
    36: 49.6,
    37: 48.6,
    38: 47.7,
    39: 46.7,
    40: 45.8,
    41: 44.8,
    42: 43.9,
    43: 42.9,
    44: 41.9,
    45: 41,
    46: 40,
    47: 39.1,
    48: 38.1,
    49: 37.2,
    50: 36.2,
    51: 35.3,
    52: 34.4,
    53: 33.5,
    54: 32.5,
    55: 31.6,
    56: 30.7,
    57: 29.9,
    58: 29,
    59: 28.1,
    60: 27.3,
    61: 26.4,
    62: 25.6,
    63: 24.7,
    64: 23.9,
    65: 23.1,
    66: 22.3,
    67: 21.5,
    68: 20.7,
    69: 19.9,
    70: 19.1,
    71: 18.3,
    72: 17.5,
    73: 16.8,
    74: 16.1,
    75: 15.3,
    76: 14.6,
    77: 14,
    78: 13.3,
    79: 12.7,
    80: 12.1,
  },
  92: {
    20: 65,
    21: 64.1,
    22: 63.1,
    23: 62.1,
    24: 61.1,
    25: 60.2,
    26: 59.2,
    27: 58.2,
    28: 57.3,
    29: 56.3,
    30: 55.3,
    31: 54.4,
    32: 53.4,
    33: 52.5,
    34: 51.5,
    35: 50.6,
    36: 49.6,
    37: 48.6,
    38: 47.7,
    39: 46.7,
    40: 45.8,
    41: 44.8,
    42: 43.8,
    43: 42.9,
    44: 41.9,
    45: 41,
    46: 40,
    47: 39.1,
    48: 38.1,
    49: 37.2,
    50: 36.2,
    51: 35.3,
    52: 34.4,
    53: 33.5,
    54: 32.5,
    55: 31.6,
    56: 30.7,
    57: 29.8,
    58: 29,
    59: 28.1,
    60: 27.2,
    61: 26.4,
    62: 25.5,
    63: 24.7,
    64: 23.9,
    65: 23,
    66: 22.2,
    67: 21.4,
    68: 20.6,
    69: 19.8,
    70: 19,
    71: 18.3,
    72: 17.5,
    73: 16.7,
    74: 16,
    75: 15.3,
    76: 14.6,
    77: 13.9,
    78: 13.2,
    79: 12.6,
    80: 11.9,
    81: 11.4,
  },
  93: {
    20: 65,
    21: 64.1,
    22: 63.1,
    23: 62.1,
    24: 61.1,
    25: 60.2,
    26: 59.2,
    27: 58.2,
    28: 57.3,
    29: 56.3,
    30: 55.3,
    31: 54.4,
    32: 53.4,
    33: 52.5,
    34: 51.5,
    35: 50.6,
    36: 49.6,
    37: 48.6,
    38: 47.7,
    39: 46.7,
    40: 45.8,
    41: 44.8,
    42: 43.8,
    43: 42.9,
    44: 41.9,
    45: 41,
    46: 40,
    47: 39.1,
    48: 38.1,
    49: 37.2,
    50: 36.2,
    51: 35.3,
    52: 34.4,
    53: 33.4,
    54: 32.5,
    55: 31.6,
    56: 30.7,
    57: 29.8,
    58: 29,
    59: 28.1,
    60: 27.2,
    61: 26.4,
    62: 25.5,
    63: 24.7,
    64: 23.8,
    65: 23,
    66: 22.2,
    67: 21.4,
    68: 20.6,
    69: 19.8,
    70: 19,
    71: 18.2,
    72: 17.4,
    73: 16.7,
    74: 15.9,
    75: 15.2,
    76: 14.5,
    77: 13.8,
    78: 13.1,
    79: 12.5,
    80: 11.9,
    81: 11.3,
    82: 10.7,
  },
  94: {
    20: 65,
    21: 64.1,
    22: 63.1,
    23: 62.1,
    24: 61.1,
    25: 60.2,
    26: 59.2,
    27: 58.2,
    28: 57.3,
    29: 56.3,
    30: 55.3,
    31: 54.4,
    32: 53.4,
    33: 52.5,
    34: 51.5,
    35: 50.6,
    36: 49.6,
    37: 48.6,
    38: 47.7,
    39: 46.7,
    40: 45.8,
    41: 44.8,
    42: 43.8,
    43: 42.9,
    44: 41.9,
    45: 41,
    46: 40,
    47: 39.1,
    48: 38.1,
    49: 37.2,
    50: 36.2,
    51: 35.3,
    52: 34.4,
    53: 33.4,
    54: 32.5,
    55: 31.6,
    56: 30.7,
    57: 29.8,
    58: 28.9,
    59: 28.1,
    60: 27.2,
    61: 26.3,
    62: 25.5,
    63: 24.7,
    64: 23.8,
    65: 23,
    66: 22.2,
    67: 21.4,
    68: 20.6,
    69: 19.8,
    70: 19,
    71: 18.2,
    72: 17.4,
    73: 16.6,
    74: 15.9,
    75: 15.2,
    76: 14.4,
    77: 13.7,
    78: 13.1,
    79: 12.4,
    80: 11.8,
    81: 11.2,
    82: 10.6,
    83: 10,
  },
  95: {
    20: 65,
    21: 64.1,
    22: 63.1,
    23: 62.1,
    24: 61.1,
    25: 60.2,
    26: 59.2,
    27: 58.2,
    28: 57.3,
    29: 56.3,
    30: 55.3,
    31: 54.4,
    32: 53.4,
    33: 52.5,
    34: 51.5,
    35: 50.6,
    36: 49.6,
    37: 48.6,
    38: 47.7,
    39: 46.7,
    40: 45.8,
    41: 44.8,
    42: 43.8,
    43: 42.9,
    44: 41.9,
    45: 41,
    46: 40,
    47: 39.1,
    48: 38.1,
    49: 37.2,
    50: 36.2,
    51: 35.3,
    52: 34.4,
    53: 33.4,
    54: 32.5,
    55: 31.6,
    56: 30.7,
    57: 29.8,
    58: 28.9,
    59: 28.1,
    60: 27.2,
    61: 26.3,
    62: 25.5,
    63: 24.6,
    64: 23.8,
    65: 23,
    66: 22.2,
    67: 21.4,
    68: 20.6,
    69: 19.7,
    70: 18.9,
    71: 18.2,
    72: 17.4,
    73: 16.6,
    74: 15.9,
    75: 15.1,
    76: 14.4,
    77: 13.7,
    78: 13,
    79: 12.3,
    80: 11.7,
    81: 11.1,
    82: 10.5,
    83: 9.9,
    84: 9.4,
  },
  96: {
    20: 65,
    21: 64.1,
    22: 63.1,
    23: 62.1,
    24: 61.1,
    25: 60.2,
    26: 59.2,
    27: 58.2,
    28: 57.3,
    29: 56.3,
    30: 55.3,
    31: 54.4,
    32: 53.4,
    33: 52.5,
    34: 51.5,
    35: 50.6,
    36: 49.6,
    37: 48.6,
    38: 47.7,
    39: 46.7,
    40: 45.8,
    41: 44.8,
    42: 43.8,
    43: 42.9,
    44: 41.9,
    45: 41,
    46: 40,
    47: 39.1,
    48: 38.1,
    49: 37.2,
    50: 36.2,
    51: 35.3,
    52: 34.3,
    53: 33.4,
    54: 32.5,
    55: 31.6,
    56: 30.7,
    57: 29.8,
    58: 28.9,
    59: 28,
    60: 27.2,
    61: 26.3,
    62: 25.5,
    63: 24.6,
    64: 23.8,
    65: 23,
    66: 22.2,
    67: 21.3,
    68: 20.5,
    69: 19.7,
    70: 18.9,
    71: 18.1,
    72: 17.4,
    73: 16.6,
    74: 15.8,
    75: 15.1,
    76: 14.3,
    77: 13.6,
    78: 12.9,
    79: 12.3,
    80: 11.6,
    81: 11,
    82: 10.4,
    83: 9.9,
    84: 9.3,
    85: 8.8,
  },
  97: {
    20: 65,
    21: 64.1,
    22: 63.1,
    23: 62.1,
    24: 61.1,
    25: 60.2,
    26: 59.2,
    27: 58.2,
    28: 57.3,
    29: 56.3,
    30: 55.3,
    31: 54.4,
    32: 53.4,
    33: 52.5,
    34: 51.5,
    35: 50.6,
    36: 49.6,
    37: 48.6,
    38: 47.7,
    39: 46.7,
    40: 45.8,
    41: 44.8,
    42: 43.8,
    43: 42.9,
    44: 41.9,
    45: 41,
    46: 40,
    47: 39.1,
    48: 38.1,
    49: 37.2,
    50: 36.2,
    51: 35.3,
    52: 34.3,
    53: 33.4,
    54: 32.5,
    55: 31.6,
    56: 30.7,
    57: 29.8,
    58: 28.9,
    59: 28,
    60: 27.2,
    61: 26.3,
    62: 25.5,
    63: 24.6,
    64: 23.8,
    65: 23,
    66: 22.1,
    67: 21.3,
    68: 20.5,
    69: 19.7,
    70: 18.9,
    71: 18.1,
    72: 17.3,
    73: 16.6,
    74: 15.8,
    75: 15,
    76: 14.3,
    77: 13.6,
    78: 12.9,
    79: 12.2,
    80: 11.6,
    81: 11,
    82: 10.4,
    83: 9.8,
    84: 9.2,
    85: 8.7,
    86: 8.3,
  },
  98: {
    20: 65,
    21: 64.1,
    22: 63.1,
    23: 62.1,
    24: 61.1,
    25: 60.2,
    26: 59.2,
    27: 58.2,
    28: 57.3,
    29: 56.3,
    30: 55.3,
    31: 54.4,
    32: 53.4,
    33: 52.5,
    34: 51.5,
    35: 50.6,
    36: 49.6,
    37: 48.6,
    38: 47.7,
    39: 46.7,
    40: 45.8,
    41: 44.8,
    42: 43.8,
    43: 42.9,
    44: 41.9,
    45: 41,
    46: 40,
    47: 39.1,
    48: 38.1,
    49: 37.2,
    50: 36.2,
    51: 35.3,
    52: 34.3,
    53: 33.4,
    54: 32.5,
    55: 31.6,
    56: 30.7,
    57: 29.8,
    58: 28.9,
    59: 28,
    60: 27.2,
    61: 26.3,
    62: 25.5,
    63: 24.6,
    64: 23.8,
    65: 22.9,
    66: 22.1,
    67: 21.3,
    68: 20.5,
    69: 19.7,
    70: 18.9,
    71: 18.1,
    72: 17.3,
    73: 16.5,
    74: 15.8,
    75: 15,
    76: 14.3,
    77: 13.6,
    78: 12.9,
    79: 12.2,
    80: 11.5,
    81: 10.9,
    82: 10.3,
    83: 9.7,
    84: 9.2,
    85: 8.7,
    86: 8.2,
    87: 7.7,
  },
  99: {
    20: 65,
    21: 64.1,
    22: 63.1,
    23: 62.1,
    24: 61.1,
    25: 60.2,
    26: 59.2,
    27: 58.2,
    28: 57.3,
    29: 56.3,
    30: 55.3,
    31: 54.4,
    32: 53.4,
    33: 52.5,
    34: 51.5,
    35: 50.6,
    36: 49.6,
    37: 48.6,
    38: 47.7,
    39: 46.7,
    40: 45.8,
    41: 44.8,
    42: 43.8,
    43: 42.9,
    44: 41.9,
    45: 41,
    46: 40,
    47: 39.1,
    48: 38.1,
    49: 37.2,
    50: 36.2,
    51: 35.3,
    52: 34.3,
    53: 33.4,
    54: 32.5,
    55: 31.6,
    56: 30.7,
    57: 29.8,
    58: 28.9,
    59: 28,
    60: 27.2,
    61: 26.3,
    62: 25.4,
    63: 24.6,
    64: 23.8,
    65: 22.9,
    66: 22.1,
    67: 21.3,
    68: 20.5,
    69: 19.7,
    70: 18.9,
    71: 18.1,
    72: 17.3,
    73: 16.5,
    74: 15.7,
    75: 15,
    76: 14.3,
    77: 13.5,
    78: 12.8,
    79: 12.2,
    80: 11.5,
    81: 10.9,
    82: 10.2,
    83: 9.7,
    84: 9.1,
    85: 8.6,
    86: 8.1,
    87: 7.6,
    88: 7.2,
  },
  100: {
    20: 65,
    21: 64.1,
    22: 63.1,
    23: 62.1,
    24: 61.1,
    25: 60.2,
    26: 59.2,
    27: 58.2,
    28: 57.3,
    29: 56.3,
    30: 55.3,
    31: 54.4,
    32: 53.4,
    33: 52.5,
    34: 51.5,
    35: 50.6,
    36: 49.6,
    37: 48.6,
    38: 47.7,
    39: 46.7,
    40: 45.8,
    41: 44.8,
    42: 43.8,
    43: 42.9,
    44: 41.9,
    45: 41,
    46: 40,
    47: 39,
    48: 38.1,
    49: 37.1,
    50: 36.2,
    51: 35.3,
    52: 34.3,
    53: 33.4,
    54: 32.5,
    55: 31.6,
    56: 30.7,
    57: 29.8,
    58: 28.9,
    59: 28,
    60: 27.1,
    61: 26.3,
    62: 25.4,
    63: 24.6,
    64: 23.8,
    65: 22.9,
    66: 22.1,
    67: 21.3,
    68: 20.5,
    69: 19.7,
    70: 18.9,
    71: 18.1,
    72: 17.3,
    73: 16.5,
    74: 15.7,
    75: 15,
    76: 14.2,
    77: 13.5,
    78: 12.8,
    79: 12.1,
    80: 11.5,
    81: 10.8,
    82: 10.2,
    83: 9.6,
    84: 9.1,
    85: 8.5,
    86: 8,
    87: 7.6,
    88: 7.2,
    89: 6.8,
  },
  101: {
    20: 65,
    21: 64.1,
    22: 63.1,
    23: 62.1,
    24: 61.1,
    25: 60.2,
    26: 59.2,
    27: 58.2,
    28: 57.3,
    29: 56.3,
    30: 55.3,
    31: 54.4,
    32: 53.4,
    33: 52.5,
    34: 51.5,
    35: 50.6,
    36: 49.6,
    37: 48.6,
    38: 47.7,
    39: 46.7,
    40: 45.8,
    41: 44.8,
    42: 43.8,
    43: 42.9,
    44: 41.9,
    45: 41,
    46: 40,
    47: 39,
    48: 38.1,
    49: 37.1,
    50: 36.2,
    51: 35.3,
    52: 34.3,
    53: 33.4,
    54: 32.5,
    55: 31.6,
    56: 30.7,
    57: 29.8,
    58: 28.9,
    59: 28,
    60: 27.1,
    61: 26.3,
    62: 25.4,
    63: 24.6,
    64: 23.8,
    65: 22.9,
    66: 22.1,
    67: 21.3,
    68: 20.5,
    69: 19.7,
    70: 18.9,
    71: 18.1,
    72: 17.3,
    73: 16.5,
    74: 15.7,
    75: 15,
    76: 14.2,
    77: 13.5,
    78: 12.8,
    79: 12.1,
    80: 11.4,
    81: 10.8,
    82: 10.2,
    83: 9.6,
    84: 9,
    85: 8.5,
    86: 8,
    87: 7.5,
    88: 7.1,
    89: 6.7,
    90: 6.3,
  },
  102: {
    20: 65,
    21: 64.1,
    22: 63.1,
    23: 62.1,
    24: 61.1,
    25: 60.2,
    26: 59.2,
    27: 58.2,
    28: 57.3,
    29: 56.3,
    30: 55.3,
    31: 54.4,
    32: 53.4,
    33: 52.5,
    34: 51.5,
    35: 50.6,
    36: 49.6,
    37: 48.6,
    38: 47.7,
    39: 46.7,
    40: 45.8,
    41: 44.8,
    42: 43.8,
    43: 42.9,
    44: 41.9,
    45: 41,
    46: 40,
    47: 39,
    48: 38.1,
    49: 37.1,
    50: 36.2,
    51: 35.3,
    52: 34.3,
    53: 33.4,
    54: 32.5,
    55: 31.6,
    56: 30.7,
    57: 29.8,
    58: 28.9,
    59: 28,
    60: 27.1,
    61: 26.3,
    62: 25.4,
    63: 24.6,
    64: 23.7,
    65: 22.9,
    66: 22.1,
    67: 21.3,
    68: 20.5,
    69: 19.7,
    70: 18.8,
    71: 18,
    72: 17.3,
    73: 16.5,
    74: 15.7,
    75: 14.9,
    76: 14.2,
    77: 13.5,
    78: 12.8,
    79: 12.1,
    80: 11.4,
    81: 10.8,
    82: 10.1,
    83: 9.6,
    84: 9,
    85: 8.5,
    86: 8,
    87: 7.5,
    88: 7,
    89: 6.6,
    90: 6.3,
    91: 5.9,
  },
  103: {
    20: 65,
    21: 64.1,
    22: 63.1,
    23: 62.1,
    24: 61.1,
    25: 60.2,
    26: 59.2,
    27: 58.2,
    28: 57.3,
    29: 56.3,
    30: 55.3,
    31: 54.4,
    32: 53.4,
    33: 52.5,
    34: 51.5,
    35: 50.5,
    36: 49.6,
    37: 48.6,
    38: 47.7,
    39: 46.7,
    40: 45.8,
    41: 44.8,
    42: 43.8,
    43: 42.9,
    44: 41.9,
    45: 41,
    46: 40,
    47: 39,
    48: 38.1,
    49: 37.1,
    50: 36.2,
    51: 35.3,
    52: 34.3,
    53: 33.4,
    54: 32.5,
    55: 31.6,
    56: 30.7,
    57: 29.8,
    58: 28.9,
    59: 28,
    60: 27.1,
    61: 26.3,
    62: 25.4,
    63: 24.6,
    64: 23.7,
    65: 22.9,
    66: 22.1,
    67: 21.3,
    68: 20.5,
    69: 19.6,
    70: 18.8,
    71: 18,
    72: 17.3,
    73: 16.5,
    74: 15.7,
    75: 14.9,
    76: 14.2,
    77: 13.5,
    78: 12.8,
    79: 12.1,
    80: 11.4,
    81: 10.7,
    82: 10.1,
    83: 9.5,
    84: 9,
    85: 8.4,
    86: 7.9,
    87: 7.4,
    88: 7,
    89: 6.6,
    90: 6.2,
    91: 5.9,
    92: 5.5,
  },
  104: {
    20: 65,
    21: 64.1,
    22: 63.1,
    23: 62.1,
    24: 61.1,
    25: 60.2,
    26: 59.2,
    27: 58.2,
    28: 57.3,
    29: 56.3,
    30: 55.3,
    31: 54.4,
    32: 53.4,
    33: 52.5,
    34: 51.5,
    35: 50.5,
    36: 49.6,
    37: 48.6,
    38: 47.7,
    39: 46.7,
    40: 45.8,
    41: 44.8,
    42: 43.8,
    43: 42.9,
    44: 41.9,
    45: 41,
    46: 40,
    47: 39,
    48: 38.1,
    49: 37.1,
    50: 36.2,
    51: 35.3,
    52: 34.3,
    53: 33.4,
    54: 32.5,
    55: 31.6,
    56: 30.7,
    57: 29.8,
    58: 28.9,
    59: 28,
    60: 27.1,
    61: 26.3,
    62: 25.4,
    63: 24.6,
    64: 23.7,
    65: 22.9,
    66: 22.1,
    67: 21.3,
    68: 20.5,
    69: 19.6,
    70: 18.8,
    71: 18,
    72: 17.2,
    73: 16.5,
    74: 15.7,
    75: 14.9,
    76: 14.2,
    77: 13.5,
    78: 12.7,
    79: 12,
    80: 11.4,
    81: 10.7,
    82: 10.1,
    83: 9.5,
    84: 8.9,
    85: 8.4,
    86: 7.9,
    87: 7.4,
    88: 7,
    89: 6.6,
    90: 6.2,
    91: 5.8,
    92: 5.5,
    93: 5.2,
  },
  105: {
    20: 65,
    21: 64.1,
    22: 63.1,
    23: 62.1,
    24: 61.1,
    25: 60.2,
    26: 59.2,
    27: 58.2,
    28: 57.3,
    29: 56.3,
    30: 55.3,
    31: 54.4,
    32: 53.4,
    33: 52.5,
    34: 51.5,
    35: 50.5,
    36: 49.6,
    37: 48.6,
    38: 47.7,
    39: 46.7,
    40: 45.7,
    41: 44.8,
    42: 43.8,
    43: 42.9,
    44: 41.9,
    45: 41,
    46: 40,
    47: 39,
    48: 38.1,
    49: 37.1,
    50: 36.2,
    51: 35.3,
    52: 34.3,
    53: 33.4,
    54: 32.5,
    55: 31.6,
    56: 30.7,
    57: 29.8,
    58: 28.9,
    59: 28,
    60: 27.1,
    61: 26.3,
    62: 25.4,
    63: 24.6,
    64: 23.7,
    65: 22.9,
    66: 22.1,
    67: 21.3,
    68: 20.5,
    69: 19.6,
    70: 18.8,
    71: 18,
    72: 17.2,
    73: 16.5,
    74: 15.7,
    75: 14.9,
    76: 14.2,
    77: 13.4,
    78: 12.7,
    79: 12,
    80: 11.4,
    81: 10.7,
    82: 10.1,
    83: 9.5,
    84: 8.9,
    85: 8.4,
    86: 7.9,
    87: 7.4,
    88: 6.9,
    89: 6.5,
    90: 6.1,
    91: 5.8,
    92: 5.4,
    93: 5.1,
    94: 4.9,
  },
  106: {
    20: 65,
    21: 64.1,
    22: 63.1,
    23: 62.1,
    24: 61.1,
    25: 60.2,
    26: 59.2,
    27: 58.2,
    28: 57.3,
    29: 56.3,
    30: 55.3,
    31: 54.4,
    32: 53.4,
    33: 52.5,
    34: 51.5,
    35: 50.5,
    36: 49.6,
    37: 48.6,
    38: 47.7,
    39: 46.7,
    40: 45.7,
    41: 44.8,
    42: 43.8,
    43: 42.9,
    44: 41.9,
    45: 41,
    46: 40,
    47: 39,
    48: 38.1,
    49: 37.1,
    50: 36.2,
    51: 35.3,
    52: 34.3,
    53: 33.4,
    54: 32.5,
    55: 31.6,
    56: 30.7,
    57: 29.8,
    58: 28.9,
    59: 28,
    60: 27.1,
    61: 26.3,
    62: 25.4,
    63: 24.6,
    64: 23.7,
    65: 22.9,
    66: 22.1,
    67: 21.3,
    68: 20.5,
    69: 19.6,
    70: 18.8,
    71: 18,
    72: 17.2,
    73: 16.5,
    74: 15.7,
    75: 14.9,
    76: 14.2,
    77: 13.4,
    78: 12.7,
    79: 12,
    80: 11.4,
    81: 10.7,
    82: 10.1,
    83: 9.5,
    84: 8.9,
    85: 8.4,
    86: 7.9,
    87: 7.4,
    88: 6.9,
    89: 6.5,
    90: 6.1,
    91: 5.8,
    92: 5.4,
    93: 5.1,
    94: 4.8,
    95: 4.6,
  },
  107: {
    20: 65,
    21: 64.1,
    22: 63.1,
    23: 62.1,
    24: 61.1,
    25: 60.2,
    26: 59.2,
    27: 58.2,
    28: 57.3,
    29: 56.3,
    30: 55.3,
    31: 54.4,
    32: 53.4,
    33: 52.5,
    34: 51.5,
    35: 50.5,
    36: 49.6,
    37: 48.6,
    38: 47.7,
    39: 46.7,
    40: 45.7,
    41: 44.8,
    42: 43.8,
    43: 42.9,
    44: 41.9,
    45: 41,
    46: 40,
    47: 39,
    48: 38.1,
    49: 37.1,
    50: 36.2,
    51: 35.3,
    52: 34.3,
    53: 33.4,
    54: 32.5,
    55: 31.6,
    56: 30.7,
    57: 29.8,
    58: 28.9,
    59: 28,
    60: 27.1,
    61: 26.3,
    62: 25.4,
    63: 24.6,
    64: 23.7,
    65: 22.9,
    66: 22.1,
    67: 21.3,
    68: 20.5,
    69: 19.6,
    70: 18.8,
    71: 18,
    72: 17.2,
    73: 16.5,
    74: 15.7,
    75: 14.9,
    76: 14.2,
    77: 13.4,
    78: 12.7,
    79: 12,
    80: 11.4,
    81: 10.7,
    82: 10.1,
    83: 9.5,
    84: 8.9,
    85: 8.4,
    86: 7.9,
    87: 7.4,
    88: 6.9,
    89: 6.5,
    90: 6.1,
    91: 5.8,
    92: 5.4,
    93: 5.1,
    94: 4.8,
    95: 4.6,
    96: 4.3,
  },
  108: {
    20: 65,
    21: 64.1,
    22: 63.1,
    23: 62.1,
    24: 61.1,
    25: 60.2,
    26: 59.2,
    27: 58.2,
    28: 57.3,
    29: 56.3,
    30: 55.3,
    31: 54.4,
    32: 53.4,
    33: 52.5,
    34: 51.5,
    35: 50.5,
    36: 49.6,
    37: 48.6,
    38: 47.7,
    39: 46.7,
    40: 45.7,
    41: 44.8,
    42: 43.8,
    43: 42.9,
    44: 41.9,
    45: 41,
    46: 40,
    47: 39,
    48: 38.1,
    49: 37.1,
    50: 36.2,
    51: 35.3,
    52: 34.3,
    53: 33.4,
    54: 32.5,
    55: 31.6,
    56: 30.7,
    57: 29.8,
    58: 28.9,
    59: 28,
    60: 27.1,
    61: 26.3,
    62: 25.4,
    63: 24.6,
    64: 23.7,
    65: 22.9,
    66: 22.1,
    67: 21.3,
    68: 20.5,
    69: 19.6,
    70: 18.8,
    71: 18,
    72: 17.2,
    73: 16.5,
    74: 15.7,
    75: 14.9,
    76: 14.2,
    77: 13.4,
    78: 12.7,
    79: 12,
    80: 11.4,
    81: 10.7,
    82: 10.1,
    83: 9.5,
    84: 8.9,
    85: 8.4,
    86: 7.8,
    87: 7.4,
    88: 6.9,
    89: 6.5,
    90: 6.1,
    91: 5.7,
    92: 5.4,
    93: 5.1,
    94: 4.8,
    95: 4.5,
    96: 4.3,
    97: 4.1,
  },
  109: {
    20: 65,
    21: 64.1,
    22: 63.1,
    23: 62.1,
    24: 61.1,
    25: 60.2,
    26: 59.2,
    27: 58.2,
    28: 57.3,
    29: 56.3,
    30: 55.3,
    31: 54.4,
    32: 53.4,
    33: 52.5,
    34: 51.5,
    35: 50.5,
    36: 49.6,
    37: 48.6,
    38: 47.7,
    39: 46.7,
    40: 45.7,
    41: 44.8,
    42: 43.8,
    43: 42.9,
    44: 41.9,
    45: 41,
    46: 40,
    47: 39,
    48: 38.1,
    49: 37.1,
    50: 36.2,
    51: 35.3,
    52: 34.3,
    53: 33.4,
    54: 32.5,
    55: 31.6,
    56: 30.7,
    57: 29.8,
    58: 28.9,
    59: 28,
    60: 27.1,
    61: 26.3,
    62: 25.4,
    63: 24.6,
    64: 23.7,
    65: 22.9,
    66: 22.1,
    67: 21.3,
    68: 20.4,
    69: 19.6,
    70: 18.8,
    71: 18,
    72: 17.2,
    73: 16.4,
    74: 15.7,
    75: 14.9,
    76: 14.2,
    77: 13.4,
    78: 12.7,
    79: 12,
    80: 11.3,
    81: 10.7,
    82: 10.1,
    83: 9.5,
    84: 8.9,
    85: 8.4,
    86: 7.8,
    87: 7.4,
    88: 6.9,
    89: 6.5,
    90: 6.1,
    91: 5.7,
    92: 5.4,
    93: 5.1,
    94: 4.8,
    95: 4.5,
    96: 4.3,
    97: 4.1,
    98: 3.9,
  },
  110: {
    20: 65,
    21: 64.1,
    22: 63.1,
    23: 62.1,
    24: 61.1,
    25: 60.2,
    26: 59.2,
    27: 58.2,
    28: 57.3,
    29: 56.3,
    30: 55.3,
    31: 54.4,
    32: 53.4,
    33: 52.5,
    34: 51.5,
    35: 50.5,
    36: 49.6,
    37: 48.6,
    38: 47.7,
    39: 46.7,
    40: 45.7,
    41: 44.8,
    42: 43.8,
    43: 42.9,
    44: 41.9,
    45: 41,
    46: 40,
    47: 39,
    48: 38.1,
    49: 37.1,
    50: 36.2,
    51: 35.3,
    52: 34.3,
    53: 33.4,
    54: 32.5,
    55: 31.6,
    56: 30.7,
    57: 29.8,
    58: 28.9,
    59: 28,
    60: 27.1,
    61: 26.3,
    62: 25.4,
    63: 24.6,
    64: 23.7,
    65: 22.9,
    66: 22.1,
    67: 21.3,
    68: 20.4,
    69: 19.6,
    70: 18.8,
    71: 18,
    72: 17.2,
    73: 16.4,
    74: 15.7,
    75: 14.9,
    76: 14.2,
    77: 13.4,
    78: 12.7,
    79: 12,
    80: 11.3,
    81: 10.7,
    82: 10.1,
    83: 9.5,
    84: 8.9,
    85: 8.3,
    86: 7.8,
    87: 7.4,
    88: 6.9,
    89: 6.5,
    90: 6.1,
    91: 5.7,
    92: 5.4,
    93: 5.1,
    94: 4.8,
    95: 4.5,
    96: 4.3,
    97: 4.1,
    98: 3.9,
    99: 3.7,
  },
  111: {
    20: 65,
    21: 64.1,
    22: 63.1,
    23: 62.1,
    24: 61.1,
    25: 60.2,
    26: 59.2,
    27: 58.2,
    28: 57.3,
    29: 56.3,
    30: 55.3,
    31: 54.4,
    32: 53.4,
    33: 52.5,
    34: 51.5,
    35: 50.5,
    36: 49.6,
    37: 48.6,
    38: 47.7,
    39: 46.7,
    40: 45.7,
    41: 44.8,
    42: 43.8,
    43: 42.9,
    44: 41.9,
    45: 41,
    46: 40,
    47: 39,
    48: 38.1,
    49: 37.1,
    50: 36.2,
    51: 35.3,
    52: 34.3,
    53: 33.4,
    54: 32.5,
    55: 31.6,
    56: 30.7,
    57: 29.8,
    58: 28.9,
    59: 28,
    60: 27.1,
    61: 26.3,
    62: 25.4,
    63: 24.6,
    64: 23.7,
    65: 22.9,
    66: 22.1,
    67: 21.3,
    68: 20.4,
    69: 19.6,
    70: 18.8,
    71: 18,
    72: 17.2,
    73: 16.4,
    74: 15.7,
    75: 14.9,
    76: 14.2,
    77: 13.4,
    78: 12.7,
    79: 12,
    80: 11.3,
    81: 10.7,
    82: 10.1,
    83: 9.5,
    84: 8.9,
    85: 8.3,
    86: 7.8,
    87: 7.3,
    88: 6.9,
    89: 6.5,
    90: 6.1,
    91: 5.7,
    92: 5.4,
    93: 5.1,
    94: 4.8,
    95: 4.5,
    96: 4.3,
    97: 4.1,
    98: 3.9,
    99: 3.7,
    100: 3.5,
  },
  112: {
    20: 65,
    21: 64.1,
    22: 63.1,
    23: 62.1,
    24: 61.1,
    25: 60.2,
    26: 59.2,
    27: 58.2,
    28: 57.3,
    29: 56.3,
    30: 55.3,
    31: 54.4,
    32: 53.4,
    33: 52.5,
    34: 51.5,
    35: 50.5,
    36: 49.6,
    37: 48.6,
    38: 47.7,
    39: 46.7,
    40: 45.7,
    41: 44.8,
    42: 43.8,
    43: 42.9,
    44: 41.9,
    45: 41,
    46: 40,
    47: 39,
    48: 38.1,
    49: 37.1,
    50: 36.2,
    51: 35.3,
    52: 34.3,
    53: 33.4,
    54: 32.5,
    55: 31.6,
    56: 30.7,
    57: 29.8,
    58: 28.9,
    59: 28,
    60: 27.1,
    61: 26.3,
    62: 25.4,
    63: 24.6,
    64: 23.7,
    65: 22.9,
    66: 22.1,
    67: 21.3,
    68: 20.4,
    69: 19.6,
    70: 18.8,
    71: 18,
    72: 17.2,
    73: 16.4,
    74: 15.7,
    75: 14.9,
    76: 14.2,
    77: 13.4,
    78: 12.7,
    79: 12,
    80: 11.3,
    81: 10.7,
    82: 10.1,
    83: 9.5,
    84: 8.9,
    85: 8.3,
    86: 7.8,
    87: 7.3,
    88: 6.9,
    89: 6.5,
    90: 6.1,
    91: 5.7,
    92: 5.4,
    93: 5.1,
    94: 4.8,
    95: 4.5,
    96: 4.3,
    97: 4,
    98: 3.8,
    99: 3.7,
    100: 3.5,
    101: 3.4,
  },
  113: {
    20: 65,
    21: 64.1,
    22: 63.1,
    23: 62.1,
    24: 61.1,
    25: 60.2,
    26: 59.2,
    27: 58.2,
    28: 57.3,
    29: 56.3,
    30: 55.3,
    31: 54.4,
    32: 53.4,
    33: 52.5,
    34: 51.5,
    35: 50.5,
    36: 49.6,
    37: 48.6,
    38: 47.7,
    39: 46.7,
    40: 45.7,
    41: 44.8,
    42: 43.8,
    43: 42.9,
    44: 41.9,
    45: 41,
    46: 40,
    47: 39,
    48: 38.1,
    49: 37.1,
    50: 36.2,
    51: 35.3,
    52: 34.3,
    53: 33.4,
    54: 32.5,
    55: 31.6,
    56: 30.7,
    57: 29.8,
    58: 28.9,
    59: 28,
    60: 27.1,
    61: 26.3,
    62: 25.4,
    63: 24.6,
    64: 23.7,
    65: 22.9,
    66: 22.1,
    67: 21.3,
    68: 20.4,
    69: 19.6,
    70: 18.8,
    71: 18,
    72: 17.2,
    73: 16.4,
    74: 15.7,
    75: 14.9,
    76: 14.2,
    77: 13.4,
    78: 12.7,
    79: 12,
    80: 11.3,
    81: 10.7,
    82: 10,
    83: 9.4,
    84: 8.9,
    85: 8.3,
    86: 7.8,
    87: 7.3,
    88: 6.9,
    89: 6.4,
    90: 6.1,
    91: 5.7,
    92: 5.3,
    93: 5,
    94: 4.7,
    95: 4.5,
    96: 4.2,
    97: 4,
    98: 3.8,
    99: 3.6,
    100: 3.5,
    101: 3.4,
    102: 3.2,
  },
  114: {
    20: 65,
    21: 64.1,
    22: 63.1,
    23: 62.1,
    24: 61.1,
    25: 60.2,
    26: 59.2,
    27: 58.2,
    28: 57.3,
    29: 56.3,
    30: 55.3,
    31: 54.4,
    32: 53.4,
    33: 52.5,
    34: 51.5,
    35: 50.5,
    36: 49.6,
    37: 48.6,
    38: 47.7,
    39: 46.7,
    40: 45.7,
    41: 44.8,
    42: 43.8,
    43: 42.9,
    44: 41.9,
    45: 41,
    46: 40,
    47: 39,
    48: 38.1,
    49: 37.1,
    50: 36.2,
    51: 35.3,
    52: 34.3,
    53: 33.4,
    54: 32.5,
    55: 31.6,
    56: 30.7,
    57: 29.8,
    58: 28.9,
    59: 28,
    60: 27.1,
    61: 26.3,
    62: 25.4,
    63: 24.6,
    64: 23.7,
    65: 22.9,
    66: 22.1,
    67: 21.3,
    68: 20.4,
    69: 19.6,
    70: 18.8,
    71: 18,
    72: 17.2,
    73: 16.4,
    74: 15.7,
    75: 14.9,
    76: 14.1,
    77: 13.4,
    78: 12.7,
    79: 12,
    80: 11.3,
    81: 10.7,
    82: 10,
    83: 9.4,
    84: 8.9,
    85: 8.3,
    86: 7.8,
    87: 7.3,
    88: 6.9,
    89: 6.4,
    90: 6,
    91: 5.7,
    92: 5.3,
    93: 5,
    94: 4.7,
    95: 4.4,
    96: 4.2,
    97: 4,
    98: 3.8,
    99: 3.6,
    100: 3.5,
    101: 3.3,
    102: 3.2,
    103: 3.1,
  },
  115: {
    20: 65,
    21: 64.1,
    22: 63.1,
    23: 62.1,
    24: 61.1,
    25: 60.2,
    26: 59.2,
    27: 58.2,
    28: 57.3,
    29: 56.3,
    30: 55.3,
    31: 54.4,
    32: 53.4,
    33: 52.5,
    34: 51.5,
    35: 50.5,
    36: 49.6,
    37: 48.6,
    38: 47.7,
    39: 46.7,
    40: 45.7,
    41: 44.8,
    42: 43.8,
    43: 42.9,
    44: 41.9,
    45: 41,
    46: 40,
    47: 39,
    48: 38.1,
    49: 37.1,
    50: 36.2,
    51: 35.3,
    52: 34.3,
    53: 33.4,
    54: 32.5,
    55: 31.6,
    56: 30.7,
    57: 29.8,
    58: 28.9,
    59: 28,
    60: 27.1,
    61: 26.3,
    62: 25.4,
    63: 24.6,
    64: 23.7,
    65: 22.9,
    66: 22.1,
    67: 21.3,
    68: 20.4,
    69: 19.6,
    70: 18.8,
    71: 18,
    72: 17.2,
    73: 16.4,
    74: 15.7,
    75: 14.9,
    76: 14.1,
    77: 13.4,
    78: 12.7,
    79: 12,
    80: 11.3,
    81: 10.7,
    82: 10,
    83: 9.4,
    84: 8.8,
    85: 8.3,
    86: 7.8,
    87: 7.3,
    88: 6.8,
    89: 6.4,
    90: 6,
    91: 5.6,
    92: 5.3,
    93: 5,
    94: 4.7,
    95: 4.4,
    96: 4.2,
    97: 4,
    98: 3.8,
    99: 3.6,
    100: 3.4,
    101: 3.3,
    102: 3.2,
    103: 3.1,
    104: 3,
  },
  116: {
    20: 65,
    21: 64.1,
    22: 63.1,
    23: 62.1,
    24: 61.1,
    25: 60.2,
    26: 59.2,
    27: 58.2,
    28: 57.3,
    29: 56.3,
    30: 55.3,
    31: 54.4,
    32: 53.4,
    33: 52.5,
    34: 51.5,
    35: 50.5,
    36: 49.6,
    37: 48.6,
    38: 47.7,
    39: 46.7,
    40: 45.7,
    41: 44.8,
    42: 43.8,
    43: 42.9,
    44: 41.9,
    45: 41,
    46: 40,
    47: 39,
    48: 38.1,
    49: 37.1,
    50: 36.2,
    51: 35.3,
    52: 34.3,
    53: 33.4,
    54: 32.5,
    55: 31.6,
    56: 30.7,
    57: 29.8,
    58: 28.9,
    59: 28,
    60: 27.1,
    61: 26.3,
    62: 25.4,
    63: 24.6,
    64: 23.7,
    65: 22.9,
    66: 22.1,
    67: 21.3,
    68: 20.4,
    69: 19.6,
    70: 18.8,
    71: 18,
    72: 17.2,
    73: 16.4,
    74: 15.6,
    75: 14.9,
    76: 14.1,
    77: 13.4,
    78: 12.7,
    79: 12,
    80: 11.3,
    81: 10.6,
    82: 10,
    83: 9.4,
    84: 8.8,
    85: 8.3,
    86: 7.7,
    87: 7.3,
    88: 6.8,
    89: 6.4,
    90: 6,
    91: 5.6,
    92: 5.2,
    93: 4.9,
    94: 4.6,
    95: 4.4,
    96: 4.1,
    97: 3.9,
    98: 3.7,
    99: 3.5,
    100: 3.3,
    101: 3.2,
    102: 3.1,
    103: 3,
    104: 2.9,
    105: 2.8,
  },
  117: {
    20: 65,
    21: 64.1,
    22: 63.1,
    23: 62.1,
    24: 61.1,
    25: 60.2,
    26: 59.2,
    27: 58.2,
    28: 57.3,
    29: 56.3,
    30: 55.3,
    31: 54.4,
    32: 53.4,
    33: 52.5,
    34: 51.5,
    35: 50.5,
    36: 49.6,
    37: 48.6,
    38: 47.7,
    39: 46.7,
    40: 45.7,
    41: 44.8,
    42: 43.8,
    43: 42.9,
    44: 41.9,
    45: 41,
    46: 40,
    47: 39,
    48: 38.1,
    49: 37.1,
    50: 36.2,
    51: 35.3,
    52: 34.3,
    53: 33.4,
    54: 32.5,
    55: 31.6,
    56: 30.7,
    57: 29.8,
    58: 28.9,
    59: 28,
    60: 27.1,
    61: 26.3,
    62: 25.4,
    63: 24.6,
    64: 23.7,
    65: 22.9,
    66: 22.1,
    67: 21.2,
    68: 20.4,
    69: 19.6,
    70: 18.8,
    71: 18,
    72: 17.2,
    73: 16.4,
    74: 15.6,
    75: 14.9,
    76: 14.1,
    77: 13.4,
    78: 12.7,
    79: 12,
    80: 11.3,
    81: 10.6,
    82: 10,
    83: 9.4,
    84: 8.8,
    85: 8.2,
    86: 7.7,
    87: 7.2,
    88: 6.8,
    89: 6.3,
    90: 5.9,
    91: 5.5,
    92: 5.2,
    93: 4.9,
    94: 4.6,
    95: 4.3,
    96: 4,
    97: 3.8,
    98: 3.6,
    99: 3.4,
    100: 3.3,
    101: 3.1,
    102: 3,
    103: 2.9,
    104: 2.8,
    105: 2.7,
    106: 2.7,
  },
  118: {
    20: 65,
    21: 64.1,
    22: 63.1,
    23: 62.1,
    24: 61.1,
    25: 60.2,
    26: 59.2,
    27: 58.2,
    28: 57.3,
    29: 56.3,
    30: 55.3,
    31: 54.4,
    32: 53.4,
    33: 52.5,
    34: 51.5,
    35: 50.5,
    36: 49.6,
    37: 48.6,
    38: 47.7,
    39: 46.7,
    40: 45.7,
    41: 44.8,
    42: 43.8,
    43: 42.9,
    44: 41.9,
    45: 41,
    46: 40,
    47: 39,
    48: 38.1,
    49: 37.1,
    50: 36.2,
    51: 35.3,
    52: 34.3,
    53: 33.4,
    54: 32.5,
    55: 31.6,
    56: 30.7,
    57: 29.8,
    58: 28.9,
    59: 28,
    60: 27.1,
    61: 26.3,
    62: 25.4,
    63: 24.5,
    64: 23.7,
    65: 22.9,
    66: 22.1,
    67: 21.2,
    68: 20.4,
    69: 19.6,
    70: 18.8,
    71: 18,
    72: 17.2,
    73: 16.4,
    74: 15.6,
    75: 14.9,
    76: 14.1,
    77: 13.4,
    78: 12.6,
    79: 11.9,
    80: 11.3,
    81: 10.6,
    82: 10,
    83: 9.3,
    84: 8.8,
    85: 8.2,
    86: 7.7,
    87: 7.2,
    88: 6.7,
    89: 6.3,
    90: 5.8,
    91: 5.5,
    92: 5.1,
    93: 4.8,
    94: 4.5,
    95: 4.2,
    96: 3.9,
    97: 3.7,
    98: 3.5,
    99: 3.3,
    100: 3.1,
    101: 3,
    102: 2.8,
    103: 2.7,
    104: 2.6,
    105: 2.6,
    106: 2.5,
    107: 2.5,
  },
  119: {
    20: 65,
    21: 64.1,
    22: 63.1,
    23: 62.1,
    24: 61.1,
    25: 60.2,
    26: 59.2,
    27: 58.2,
    28: 57.3,
    29: 56.3,
    30: 55.3,
    31: 54.4,
    32: 53.4,
    33: 52.5,
    34: 51.5,
    35: 50.5,
    36: 49.6,
    37: 48.6,
    38: 47.7,
    39: 46.7,
    40: 45.7,
    41: 44.8,
    42: 43.8,
    43: 42.9,
    44: 41.9,
    45: 41,
    46: 40,
    47: 39,
    48: 38.1,
    49: 37.1,
    50: 36.2,
    51: 35.3,
    52: 34.3,
    53: 33.4,
    54: 32.5,
    55: 31.6,
    56: 30.7,
    57: 29.8,
    58: 28.9,
    59: 28,
    60: 27.1,
    61: 26.2,
    62: 25.4,
    63: 24.5,
    64: 23.7,
    65: 22.9,
    66: 22.1,
    67: 21.2,
    68: 20.4,
    69: 19.6,
    70: 18.8,
    71: 18,
    72: 17.2,
    73: 16.4,
    74: 15.6,
    75: 14.8,
    76: 14.1,
    77: 13.4,
    78: 12.6,
    79: 11.9,
    80: 11.2,
    81: 10.6,
    82: 9.9,
    83: 9.3,
    84: 8.7,
    85: 8.2,
    86: 7.6,
    87: 7.1,
    88: 6.6,
    89: 6.2,
    90: 5.8,
    91: 5.4,
    92: 5,
    93: 4.7,
    94: 4.4,
    95: 4.1,
    96: 3.8,
    97: 3.6,
    98: 3.3,
    99: 3.1,
    100: 2.9,
    101: 2.8,
    102: 2.6,
    103: 2.5,
    104: 2.4,
    105: 2.4,
    106: 2.3,
    107: 2.3,
    108: 2.3,
  },
  120: {
    20: 65,
    21: 64.1,
    22: 63.1,
    23: 62.1,
    24: 61.1,
    25: 60.2,
    26: 59.2,
    27: 58.2,
    28: 57.3,
    29: 56.3,
    30: 55.3,
    31: 54.4,
    32: 53.4,
    33: 52.5,
    34: 51.5,
    35: 50.5,
    36: 49.6,
    37: 48.6,
    38: 47.7,
    39: 46.7,
    40: 45.7,
    41: 44.8,
    42: 43.8,
    43: 42.9,
    44: 41.9,
    45: 41,
    46: 40,
    47: 39,
    48: 38.1,
    49: 37.1,
    50: 36.2,
    51: 35.3,
    52: 34.3,
    53: 33.4,
    54: 32.5,
    55: 31.6,
    56: 30.6,
    57: 29.8,
    58: 28.9,
    59: 28,
    60: 27.1,
    61: 26.2,
    62: 25.4,
    63: 24.5,
    64: 23.7,
    65: 22.9,
    66: 22,
    67: 21.2,
    68: 20.4,
    69: 19.6,
    70: 18.8,
    71: 18,
    72: 17.2,
    73: 16.4,
    74: 15.6,
    75: 14.8,
    76: 14.1,
    77: 13.3,
    78: 12.6,
    79: 11.9,
    80: 11.2,
    81: 10.5,
    82: 9.9,
    83: 9.3,
    84: 8.7,
    85: 8.1,
    86: 7.6,
    87: 7.1,
    88: 6.6,
    89: 6.1,
    90: 5.7,
    91: 5.3,
    92: 4.9,
    93: 4.6,
    94: 4.3,
    95: 4,
    96: 3.7,
    97: 3.4,
    98: 3.2,
    99: 3,
    100: 2.8,
    101: 2.6,
    102: 2.5,
    103: 2.3,
    104: 2.2,
    105: 2.1,
    106: 2.1,
    107: 2.1,
    108: 2,
    109: 2,
  },
};

// Lookup helper - enforces the IRS "spouse more than 10 years younger" rule.
export function jointRmdDivisor(ownerAge, spouseAge) {
  if (spouseAge == null || !Number.isFinite(spouseAge)) {
    return null;
  }
  const oa = Number(ownerAge);
  const sa = Number(spouseAge);
  if (!Number.isFinite(oa)) {
    return null;
  }
  // IRS rule: spouse must be MORE than 10 years younger
  if (sa >= oa - 10) {
    return null;
  }
  const row = JOINT_RMD_TABLE_II[String(oa)];
  if (!row) {
    return null;
  }
  return row[String(sa)] ?? null;
}